<template>
  <div class="modal-wrap">
  <h1 class="tit-h1 d-flex">
    기업상세정보
    <div class="ml-auto align-self-center">
      <v-icon x-small class="svg-close20" @click="$emit('hide')"></v-icon>
    </div>
  </h1>
  <div class="modal-box">
    <!-- 신규 기업 등록 다이얼로그 시작 -->
    <div class="box-ct">
      <div class="table-form">
        <h2 class="tit-h2">
          이용서비스정보
        </h2>
        <table class="mt-3">
          <colgroup>
            <col width="127px" />
            <col width="" />
            <col width="127px" />
            <col width="" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">
                <v-badge dot color="#EF9191">이용서비스</v-badge>
              </th>
              <td>
                <div class="form-inp full">
                  <v-select
                    :items="USE_SRV"
                    item-value="CD"
                    item-text="CD_NM"
                    outlined
                    hide-details
                    placeholder="선택하세요"
                    v-model="USE_NEWSRV"
                  >
                  </v-select>
                </div>
              </td>
              <th scope="row">
                <v-badge dot color="#EF9191">서비스유지여부</v-badge>
              </th>
              <td>
                <div class="form-inp full">
                  <v-select
                    :items="SRV_YN"
                    item-value="CD"
                    item-text="CD_NM"
                    outlined
                    hide-details
                    placeholder="선택하세요"
                    v-model="SRV_NEWYN"
                  >
                  </v-select>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <v-badge dot color="#EF9191">서비스시작일시</v-badge>
              </th>
              <td>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  content-class="calendar-modal dateTime"
                  color="#FFF"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormatted2"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      hide-details
                      class="form-inp icon-calendar"
                      append-icon="svg-calendar"
                    ></v-text-field>
                  </template>
                  <div class="d-flex">
                    <v-date-picker
                        v-model="date2"
                        dark
                        color="#F7AFAE"
                        show-current="false"
                        class="borderR16"
                        :first-day-of-week="1"
                        locale="ko-KR"
                        :day-format="mixin_getDate"
                      ></v-date-picker>
                      <v-time-picker
                        v-model="timeStep2"
                        :allowed-minutes="allowedStep2"
                        color="#F7AFAE"
                        format="24hr"
                        class="borderR16"
                        @click:minute="$refs.menu2.save(time)"
                      ></v-time-picker>
                    </div>
                </v-menu>
              </td>
              <th scope="row">
                <v-badge dot color="#EF9191">서비스종료일시</v-badge>
              </th>
              <td>
                <v-menu
                  ref="menu4"
                  v-model="menu4"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  content-class="calendar-moda dateTimel"
                  color="#FFF"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="computedDateFormatted4"
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      hide-details
                      class="form-inp icon-calendar"
                      append-icon="svg-calendar"
                    ></v-text-field>
                  </template>
                  <div class="d-flex">
                    <v-date-picker
                        v-model="date4"
                        dark
                        color="#F7AFAE"
                        show-current="false"
                        class="borderR16"
                        :first-day-of-week="1"
                        locale="ko-KR"
                        :day-format="mixin_getDate"
                      ></v-date-picker>
                      <v-time-picker
                        v-model="timeStep4"
                        :allowed-minutes="allowedStep4"
                        color="#F7AFAE"
                        format="24hr"
                        class="borderR16"
                        @click:minute="$refs.menu4.save(time)"
                      ></v-time-picker>
                    </div>
                </v-menu>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <v-badge dot color="#EF9191">계정생성제한건수</v-badge>
              </th>
              <td>
                <v-text-field
                  class="form-inp full"
                  name="name" value="계정생성제한건수" id="id" outlined hide-details=""
                  v-model="LIMIT_NEWMAKE">
                </v-text-field>
              </td>
              <th scope="row">
                <v-badge dot color="#EF9191">전화번호</v-badge>
              </th>
              <td>
                <v-text-field
                  class="form-inp full"
                  name="name" value="전화번호" id="id" outlined hide-details=""
                  v-model="PHONE_NEWNUM">
                </v-text-field>
              </td>
            </tr>
          </tbody>
        </table>
        <h2 class="tit-h2 mt-3">
          기업기본정보
        </h2>
        <table class="mt-3">
          <colgroup>
            <col width="127px" />
            <col width="" />
            <col width="127px" />
            <col width="" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">
                <v-badge dot color="#EF9191">기업명</v-badge>
              </th>
              <td>
                <v-text-field
                  class="form-inp full"
                  name="name" value="기업명" id="id" outlined hide-details=""
                  v-model="COMPANY_NEWNM">
                </v-text-field>
              </td>
              <th scope="row">
                <v-badge dot color="#EF9191">사업자등록번호</v-badge>
              </th>
              <td>
                <v-text-field
                  class="form-inp full"
                  name="name" value="사업자등록번호" id="id" outlined hide-details=""
                  v-model="BUSI_NEWREGIST">
                </v-text-field>
              </td>
            </tr>
          </tbody>
        </table>
        <h2 class="tit-h2 mt-3">
          등록자정보
        </h2>
        <table class="mt-3">
          <colgroup>
            <col width="127px" />
            <col width="" />
            <col width="127px" />
            <col width="" />
          </colgroup>
          <tbody>
            <tr>
              <th scope="row">
                <v-badge dot color="#EF9191">등록자ID</v-badge>
              </th>
              <td>
                <v-text-field
                  class="form-inp full"
                  name="name" value="등록자ID" id="id" outlined hide-details=""
                  v-model="PROC_NEWID"
                  readonly>
                </v-text-field>
              </td>
              <th scope="row">
                <v-badge dot color="#EF9191">등록자명</v-badge>
              </th>
              <td>
                <v-text-field
                  class="form-inp full"
                  name="name" value="등록자명" id="id" outlined hide-details=""
                  v-model="PROC_NEWID"
                  readonly>
                </v-text-field>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <v-badge dot color="#EF9191">등록일시</v-badge>
              </th>
              <td>
                <v-text-field
                  class="form-inp full"
                  name="name" value="등록일시" id="id" outlined hide-details=""
                  v-model="IT_NEWPROCESSING"
                  readonly>
                </v-text-field>
              </td>
              <th scope="row">

              </th>
              <td>

              </td>
            </tr>
          </tbody>
        </table>
        <div class="text-right mt-3">
          <v-btn v-if="this.mixin_set_btn(this.$options.name, 'btnSave')" outlined class="btn-point" v-on:click="showAlertReg"> 저장 </v-btn>
        </div>
      </div>
    </div>
    <!-- 신규 기업 등록 다이얼로그 -->
  </div>
  </div>
</template>

<script>
import api from '../../store/apiUtil.js';
import { mixin } from "@/mixin/mixin.js";

export default {
  name: "MENU_M810706P03", //name은 'MENU_' + 파일명 조합
  mixins: [mixin],
  props: {
    detailAsp: {
      type:Object,
      value:{}
    },
  },
  computed: {
  },
  components: {
  },
  data() {
    return {
      menu2: false,
      menu4: false,
      date2: this.detailAsp.ST_DATE,
      date4: this.detailAsp.END_DATE,
      timeStep2: this.detailAsp.ST_TM,
      timeStep4: this.detailAsp.END_TM,
      gridDataHeaders2: [
        {
          text: 'No',
          align: 'center',
          value: 'index',
          width: '50px',
          sortable: false,
        },
        {text:"고객사ID", value: 'ASP_CUST_KEY', align: 'center', sortable: false, },
        {text:"고객사명", value: 'COMPANY_NM', align: 'center', sortable: false, },
        {text:"전화번호", value: 'PHONE_NUM', align: 'center', sortable: false, },
        {text:"큐번호", value: 'QUEUE_NUM', align: 'center', sortable: false, },
        {text:"등록자ID", value: 'REGR_ID', align: 'center', sortable: false, },
        {text:"최근수정일시", value: 'REG_DTTM', align: 'center', sortable: false, },
        ],
      gridDataText2: [],
      page2: 1,
      pageCount2: 0,
      itemsPerPage2: 5,
      totalVisible2: 10,

      USE_SRV:[
        {
          CD: '',
          CD_NM: '선택'
        },
        {
          CD: 'TRIAL',
          CD_NM: '테스터'
        },
        {
          CD: 'STANDARD',
          CD_NM: '스탠다드'
        },
        {
          CD: 'ENTERPRISE',
          CD_NM: '엔터프라이즈'
        },
        {
          CD: 'FRIENDS',
          CD_NM: '프렌즈'
        },
      ],

      SRV_YN:[
        {
          CD: '',
          CD_NM: '선택'
        },
        {
          CD: 'Y',
          CD_NM: '사용'
        },
        {
          CD: 'N',
          CD_NM: '미사용'
        },
      ],

      LIMIT_NEWMAKE: '',
      PHONE_NEWNUM: '',
      COMPANY_NEWNM:'',
      COMPANY_NEWNUM:'',

      ASP_NEWCUST_KEY: this.detailAsp.ASP_CUST_INFO,
      USE_NEWSRV: this.detailAsp.PRODUCT_CD,
      SRV_NEWYN: this.detailAsp.SERV_KEEP_YN,
      SERV_START_NEWDTTM: this.detailAsp.SERV_START_DTTM,
      SERV_END_NEWDTTM: this.detailAsp.SERV_END_DTTM,
      LIMIT_NEWMAKE: this.detailAsp.ACCOUNT_CREATION_LIMIT,
      PHONE_NEWNUM: this.detailAsp.PHONE_NUM,
      COMPANY_NEWNM: this.detailAsp.COMPANY_NM,
      BUSI_NEWREGIST: this.detailAsp.BUSI_REGIST,
      SRV_NEWYN: this.detailAsp.SERV_KEEP_YN,

      PROC_NEWID: this.detailAsp.PROC_ID,
      IT_NEWPROCESSING: this.detailAsp.IT_PROCESSING,

      ST_NEWDATE: this.detailAsp.ST_DATE,
      ST_NEWTM: this.detailAsp.ST_TM,
      END_NEWDATE: this.detailAsp.END_DATE,
      END_NEWTM: this.detailAsp.END_TM,
    };
  },

  created() {
  },

  methods: {
    formatDate (date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
    allowedStep2: (m) => m % 10 === 0,
    allowedStep4: (m) => m % 10 === 0,

    btnModiAsp(){
      if (this.USE_NEWSRV == "" || this.USE_NEWSRV == undefined) {
        this.showAlert("이용서비스를 선택해주세요.");
        return;
      }
      if (this.SRV_NEWYN == "" || this.SRV_NEWYN == undefined) {
        this.showAlert("서비스 유지여부를 선택해주세요.");
        return;
      }
      if (this.LIMIT_NEWMAKE == "" || this.LIMIT_NEWMAKE == undefined) {
        this.showAlert("계정 생성 제한건수를 확인해주세요.");
        return;
      }
      if (this.PHONE_NEWNUM == "" || this.PHONE_NEWNUM == undefined) {
        this.showAlert("전화번호를 입력해주세요.");
        return;
      }
      if (this.COMPANY_NEWNM == "" || this.COMPANY_NEWNM == undefined) {
        this.showAlert("기업명을 입력해주세요.");
        return;
      }
      if (this.BUSI_NEWREGIST == "" || this.BUSI_NEWREGIST == undefined) {
        this.showAlert("사업자 등록번호를 입력해주세요.");
        return;
      }
      let DT1 = this.date2
      let DT1_Array = DT1.split("-");
      var ST_DATE = DT1_Array[0] + DT1_Array[1] + DT1_Array[2];

      let TM1_Array = this.timeStep2;
      var ST_TM = TM1_Array[0] + TM1_Array[1];

      let DT2 = this.date4;
      let DT2_Array = DT2.split("-");
      var END_DATE = DT2_Array[0] + DT2_Array[1] + DT2_Array[2];

      let TM2_Array = this.timeStep4;
      var END_TM = TM2_Array[0] + TM2_Array[1];

      console.log("END_DATE" + END_DATE);
      console.log("END_TM" + END_TM);

      api.post("api/setting/system/entrprs-acnt-manage/ctmmny-detail-popup/modify",   //api url입력
      {
        ASP_CUST_INFO: this.ASP_NEWCUST_KEY,
        PRODUCT_CD: this.USE_NEWSRV,
        SERV_KEEP_YN: this.SRV_NEWYN,
        SERV_START_DTTM: ST_DATE+ST_TM,
        SERV_START_DATE: ST_DATE,
        SERV_START_TIME: ST_TM,
        SERV_END_DTTM: END_DATE+END_TM,
        SERV_END_DATE: END_DATE,
        SERV_END_TIME: END_TM,
        ACCOUNT_CREATION_LIMIT: this.LIMIT_NEWMAKE,
        PHONE_NUM: this.PHONE_NEWNUM,
        COMPANY_NM: this.COMPANY_NEWNM,
        BUSI_REGIST: this.BUSI_NEWREGIST,
        CUST_AGREE_YN: 'Y',
        AMDR_DEPT_CD: 'x',
        AMDR_ID: this.$store.getters['userStore/GE_USER_ROLE'].userId,
        PROC_ID: this.$store.getters['userStore/GE_USER_ROLE'].userId,
        REG_ID: this.$store.getters['userStore/GE_USER_ROLE'].userId,
        ASP_USER_ID: this.$store.getters['userStore/GE_USER_ROLE'].userId,
        ASP_CUST_KEY: this.$store.getters['userStore/GE_USER_ROLE'].company[0].CD,
      },
      {head: {
        "SERVICE" : "setting.system.entrprs-acnt-manage.ctmmny-detail-popup",
        "METHOD" : "modify",
        "TYPE" : "BIZ_SERVICE",
      }})
      .then((response) => {
        this.$emit("Qsave","selectList")
      })
      .catch((err) => {
        alert(err);
      })

    },

    showAlert(msg) {
      this.$store.commit("alertStore/openAlertDialog", {
        alertDialogToggle: true,
        msg: msg,
        iconClass: "svg-error-lg",
        type: "default",
      });
    },

    showAlertReg(){
      this.$store.commit("alertStore/openAlertDialog", {
        alertDialogToggle: true,
        msg: '기업정보를 수정하시겠습니까?',
        iconClass: 'svg-chk-lg',
        type: 'confirm',
        callYes: this.callYes,
        callNo: this.callNo,
      })
    },

    callYes() {
      this.$store.commit("alertStore/openAlertDialog", {
      alertDialogToggle: false,
      });
      this.btnModiAsp();
    },

    callNo(){
      this.$store.commit("alertStore/openAlertDialog", {
        alertDialogToggle: false,
      });
    },

    success(){
      this.$store.commit("alertStore/openAlertDialog", {
        alertDialogToggle: true,
        msg: '정상처리 되었습니다.',
        iconClass: 'svg-done-lg',
        type: 'default'
      })
    },

    fail(){
      this.$store.commit("alertStore/openAlertDialog", {
        alertDialogToggle: true,
        msg: '시스템 장애가 일어났습니다.<br>잠시후에 다시 시도해주세요.',
        iconClass: 'svg-error-lg',
        type: 'default'
      })
    },
  },
  computed: {
    computedDateFormatted2(){
      return `${this.date2} ${this.timeStep2}`
    },
    computedDateFormatted4(){
      return `${this.date4} ${this.timeStep4}`
    },
  },
  watch: {
    detailAsp(){
      this.ASP_NEWCUST_KEY = this.detailAsp.ASP_CUST_INFO,
      this.USE_NEWSRV = this.detailAsp.PRODUCT_CD,
      this.SRV_NEWYN = this.detailAsp.SERV_KEEP_YN,
      this.SERV_START_NEWDTTM = this.detailAsp.SERV_START_DTTM,
      this.SERV_END_NEWDTTM = this.detailAsp.SERV_END_DTTM,
      this.LIMIT_NEWMAKE = this.detailAsp.ACCOUNT_CREATION_LIMIT,
      this.PHONE_NEWNUM = this.detailAsp.PHONE_NUM,
      this.COMPANY_NEWNM = this.detailAsp.COMPANY_NM,
      this.BUSI_NEWREGIST = this.detailAsp.BUSI_REGIST,
      this.SRV_NEWYN = this.detailAsp.SERV_KEEP_YN,

      this.PROC_NEWID = this.detailAsp.PROC_ID,
      this.IT_NEWPROCESSING = this.detailAsp.IT_PROCESSING,

      this.date2 = this.detailAsp.ST_DATE;
      this.timeStep2 = this.detailAsp.ST_TM;
      this.date4 = this.detailAsp.END_DATE;
      this.timeStep2 = this.detailAsp.ST_TM;
    }
  }
};
</script>

<style></style>
